import { from } from 'rxjs'

import { BillingAPI } from 'api'
import { rxCheckStatus, rxPluckData } from 'utils/api'

export const api = {
  fetchBillingDeal(dealCode) {
    return from(BillingAPI.get(`/deals/${dealCode}`)).pipe(
      rxCheckStatus(),
      rxPluckData()
    )
  },
  activateDeal({ dealId, accessToken }) {
    console.warn(
      'we should not be here in activateDeal - redirecting to activateDealV2'
    )
    return this.activateDealV2(dealId, accessToken)
  },
  activateDealV2({ dealId, accessToken }) {
    return from(
      BillingAPI.post(
        '/deals/v2/activate',
        {
          dealId,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
    ).pipe(rxCheckStatus())
  },
}
